import React, { useEffect, useState } from "react";
import svJSON from "../config/languages/sv.json";
import enJSON from "../config/languages/en.json";
import { Language, TranslationData } from "@common";

interface LangStore {
  lang: Language;
}

interface LangContextType {
  translatePageText: (key: string) => string;
  translateTranslationData: (translationData: TranslationData | undefined) => string;
  i18n: {
    lang: Language;
    changeLanguage: (lang: "sv" | "en") => void;
  };
}

export const LangContext = React.createContext<LangContextType>({
  translatePageText: () => "",
  translateTranslationData: () => "",
  i18n: { lang: "sv", changeLanguage: () => null },
});

export const LangProvider: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const [langStore, setLangStore] = useState<LangStore>({
    lang: "sv",
  });
  const [json, setJSON] = useState<any>(svJSON);

  useEffect(() => {
    setJSON(langStore.lang === "sv" ? svJSON : enJSON);
  }, [langStore.lang]);

  const i18n = {
    lang: langStore.lang,
    changeLanguage: (lang: "sv" | "en") => setLangStore({ lang: lang }),
  };

  const translateTranslationData = (translationData: TranslationData | undefined): string => {
    return translationData ? translationData[langStore.lang] : "";
  };

  const translatePageText = (key: string) => {
    try {
      const val = key.split(".").reduce((o, i) => o[i], json);
      if (val === undefined) {
        console.error("Couldn't find value with key ", key);
      }
      return val;
    } catch {
      console.error("Couldn't find value with key ", key);
      return key;
    }
  };

  return (
    <LangContext.Provider value={{ translatePageText, translateTranslationData, i18n }}>
      {children}
    </LangContext.Provider>
  );
};
